







import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { HisInformationListItem } from "../../../domain/his/HisInformationListItem";
import { HisInformationItem } from "../../../domain/his";
import { DialogSelectableMixin, StandardOption } from "../../system/selectors/mixins";
import { DepartmentGroup } from "../../../domain/department";
import { OptionDropDownSelector } from "../../system";
import { DomainRegistry } from "../../../domain";

@Component({
  components: {
    selector: OptionDropDownSelector,
  }
})

export default class DepartmentGroupFilter extends Mixins(DialogSelectableMixin) {
  data(): any {
    return {
      departmentGroupOptions: [new StandardOption<DepartmentGroup>("指定なし", null)],
      selectedDepartmentGroup: null as DepartmentGroup,
    };
  }
  departmentGroupOptions: StandardOption<DepartmentGroup>[];
  selectedDepartmentGroup: DepartmentGroup;

  mounted() {
    this.setOptions();
  }

  @Watch("selectedDepartmentGroup")
  onSelectedDepartmentGroupUpdated(): void {
    this.editingSource = this.createFilter();
  }

  createFilter(): (s: HisInformationListItem) => boolean {
    if (!this.selectedDepartmentGroup) { return s => true; }
    const departementIds = this.selectedDepartmentGroup.departments.map(d => d.id);
    // 現状では入院情報のみをフィルターの対象としている
    // 診療科コードは一覧では非表示とされる想定
    return s => this.contains(s.items.concat(s.invisibleItems), "ENTER_HOSP_MED_DEP_CODE", departementIds);
  }

  contains(items: HisInformationItem[], name: string, values: string[]): boolean {
    return Enumerable.from(items).any(i => (i.name === name) && (values.some(v => v === i.value)));
  }

  async setOptions(): Promise<void> {
    const departmentGroups = await DomainRegistry.department.getDepartmentRepository().getDepartmentGroups();
    const departmentGroupOptions = Enumerable.from(departmentGroups)
      .where(g => !g.isDeleted && g.departments.length !== 0)
      .select(g => new StandardOption<DepartmentGroup>(g.name, g))
      .toArray();
    departmentGroupOptions.unshift(new StandardOption<DepartmentGroup>("指定なし", null));
    this.departmentGroupOptions = departmentGroupOptions;
  }
}
